'use client';

import { ReactNode } from 'react';
import styles from './ContactContent.module.scss';

export interface ContactInfo {
  phone?: string;
  email?: string;
  hours?: string;
  address?: string;
}

export interface ContactContentProps {
  children: ReactNode;
  contactInfo?: ContactInfo;
}

export function ContactContent({ children, contactInfo }: ContactContentProps) {
  return (
    <div className={styles.mainSection}>
      <div className={styles.contentWrapper}>
        <div className={styles.formContent}>
          {children}
        </div>

        {contactInfo && (
          <aside className={styles.contactSidebar}>
            <h2 className={styles.sidebarTitle}>お問い合わせ情報</h2>
            
            {contactInfo.phone && (
              <div className={styles.contactItem}>
                <h3>電話番号</h3>
                <p>{contactInfo.phone}</p>
              </div>
            )}

            {contactInfo.email && (
              <div className={styles.contactItem}>
                <h3>メールアドレス</h3>
                <p>
                  <a href={`mailto:${contactInfo.email}`}>
                    {contactInfo.email}
                  </a>
                </p>
              </div>
            )}

            {contactInfo.hours && (
              <div className={styles.contactItem}>
                <h3>営業時間</h3>
                <p>{contactInfo.hours}</p>
              </div>
            )}

            {contactInfo.address && (
              <div className={styles.contactItem}>
                <h3>所在地</h3>
                <p>{contactInfo.address}</p>
              </div>
            )}

            <div className={styles.contactNote}>
              <p>
                お問い合わせいただいた内容は、1営業日以内に返信いたします。
                お急ぎの場合は、お電話でのお問い合わせをお願いいたします。
              </p>
            </div>
          </aside>
        )}
      </div>
    </div>
  );
}